import React from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Box, Grid, Stack, Typography } from '@mui/material'
import BackButtonSquare from 'common/Button/BackButtonSquare'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'
import { useFormik } from 'formik'
import { generateManualDeliveryValidationSchema } from 'helpers/formValidationSchema'

import ColorBox from '../../../../../../../common/Box/ColorWhiteBox'
import OrderDetailsProgressMain from '../OrderDetailsProgress/OrderDetailsProgressMain'

import CustomerDetailsBox from './CustomerDetailsBox'
import ManualDeliveryRescheduling from './ManualDeliveryRescheduling'
import ManualDeliveryScheduling from './ManualDeliveryScheduling'

interface ModeProps {
  mode: string
  confirmScheduledDelivery: (value: void) => void
}

const ManualDeliveryMain = () => {
  const formik = useFormik({
    initialValues: {
      deliveryCompany: '',
      deliveryDate: '',
      deliveryTime: ''
    },
    validationSchema: generateManualDeliveryValidationSchema(),
    onSubmit: (values) => {
      toast.error(JSON.stringify(values))
    }
  })
  const state = useLocation().state as ModeProps

  const navigate = useNavigate()
  const { id } = useParams()
  return state === null ? (
    <Navigate to='/hq/manage-orders/individual-order' />
  ) : (
    <PageLayoutV2 header='Individual Order'>
      <Stack direction='row' justifyContent='space-between'>
        <Box sx={{ width: '70%' }}>
          <ColorBox>
            <>
              <Stack direction='row' alignItems='center' spacing={2}>
                <BackButtonSquare
                  onClick={() =>
                    navigate(`/hq/manage-orders/individual-order/${id}`)
                  }
                />
                <Typography variant='h5'>
                  {state.mode === 'initialDelivery'
                    ? 'Manual Delivery'
                    : 'Reschedule Delivery'}
                </Typography>
              </Stack>
              <CustomerDetailsBox />

              {state.mode === 'initialDelivery' && (
                <ManualDeliveryScheduling formik={formik} />
              )}
              {state.mode === 'rescheduleDelivery' && (
                <ManualDeliveryRescheduling formik={formik} />
              )}
            </>
          </ColorBox>
        </Box>
        <Grid container spacing={3} direction='column' sx={{ width: '30%' }}>
          <OrderDetailsProgressMain />
        </Grid>
      </Stack>
    </PageLayoutV2>
  )
}

export default ManualDeliveryMain
